import { ConfigFn } from '@config/types'

const config = (({ staticAssetDomain }) =>
  ({
    allowedOriginsToReceivePostMessage: [
      staticAssetDomain,
      'https://www.blick.ch',
      'https://next-stg.blick.ch',
      'https://next-test.blick.ch',
      'https://next-pre.blick.ch',
      'https://php.blick.ch',
      'https://storytelling.blick.ch',
      //* Sailthru
      'https://link-ssr.stg.blick.ch',
      'https://link.blick.ch',
      'https://link2.blick.ch',
    ],
  }) as const) satisfies ConfigFn

export default config
